<template>
    <div class="projects">
        <div v-for="(project, index) in projects" v-bind:key="index" class="project">
            <router-link :to="{ name: 'ProjectDetails', params: { appName: project.link }}" class="project-link">  
                <div class="metadata">
                    <span class="title">{{ project.title }}</span>
                </div>
            
                <img :src="assetPath(project.logo)" class="logo">
            </router-link>
       
            <div class="store-links">
                <a :href="project.appleLink">
                    <img src="../assets/AppleStoreLink.png" class="store-link">
                </a>
                <a :href="project.androidLink">
                    <img src="../assets/GooglePlayLink.png" class="store-link">
                </a>
            </div>
          
        </div> 
    </div>
</template>

<script>
import json from "../data/projects.json";

export default {
    data() {
        return {
            projects: json.projects
        } 
    },
    methods:{
        assetPath(asset)
        {
            return require('../assets/' + asset);
        }
    }
}
</script>

<style>

.projects
{
    display: flex;
    margin-top: 4rem;
    margin-bottom: 4rem;
    column-gap: 2rem;
    row-gap: 2rem;
    flex-wrap: wrap;
    justify-content: center;
    transition: 0.3s;
}

.projects .project
{
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    color: black;
    justify-content: center;
    text-decoration: none;
    background:white;
    border-radius: 20px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    margin:1rem
}

.project-link
{
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: black;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    overflow: hidden;
}
.projects .project .project-link:hover, .projects .project .store-link:hover 
{
    background: #E4E4E4;
    /* box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2); */
} 
.projects .project .metadata
{
    padding: 2rem;
}

.projects .project .metadata .title
{
    display: flex;
    font-weight: bold;
    font-size: 23px;
}

.projects .project .logo
{
    max-width: 24rem;
    max-height: 24rem;
    align-self: center;
}
 .store-links
{
    display: flex;
    justify-content: space-evenly;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    overflow: hidden;
   
}
 .store-links .store-link
{
    overflow: hidden;
    max-width: 12rem;
    object-fit: contain;
    height: 100%;
}
</style>